module.exports = __webpack_public_path__ + "img/picture.35f00ed7.png";